import { enqueueSnackbar, SnackbarMessage } from "notistack";
import { messaging, getToken, onMessage } from "../../../firebase";
import { getFBaseToken } from "core/hooks/useGetFirebaseToken";
import { IParams, tryFetch } from "helpers/FetchAPI";

import { getTokenOrDefault } from "helpers/Storage";
export function openSidebar() {
	if (typeof window !== 'undefined') {
		document.body.style.overflow = 'hidden';
		document.documentElement.style.setProperty('--SideNavigation-slideIn', '1');
	}
}

export function closeSidebar() {
	if (typeof window !== 'undefined') {
		document.documentElement.style.removeProperty('--SideNavigation-slideIn');
		document.body.style.removeProperty('overflow');
	}
}

export function toggleSidebar() {
	if (typeof window !== 'undefined' && typeof document !== 'undefined') {
		const slideIn = window
			.getComputedStyle(document.documentElement)
			.getPropertyValue('--SideNavigation-slideIn');
		if (slideIn) {
			closeSidebar();
		} else {
			openSidebar();
		}
	}
}

export function pageAlert(component: SnackbarMessage, variant: "info" | "default" | "error" | "warning" | "success" | undefined) {
	return enqueueSnackbar(component, { variant: variant, hideIconVariant: true })
}


export const requestFCMPermission = async () => {
const token = getTokenOrDefault();

	const TOKEN = await getFBaseToken();
  try {
	const permission = await Notification.requestPermission();
	if (permission === "granted") {
	  try {
		if (TOKEN) {	

		  const params: IParams = {
			url: `/security/fcm`,
			method: "POST",
			token: token,
			payload: { token: TOKEN },
		  };

		  await tryFetch(params);

		  // Send the token to your backend
		  // await fetch("http://127.0.0.1:5800/api/v1/security/fcm", {
		  //   method: "POST",
		  //   headers: {
		  //     "Content-Type": "application/json",
		  //     Accept: "application/json",
		  //   },
		  //   body: JSON.stringify({ token }),
		  // });
		} else {
		  console.log("No FCM token available.");
		}
	  } catch (error) {
		console.error("Error getting FCM token:", error);
	  }
	} else {
	  console.log("Notification permission denied.");
	}
  } catch (error) {
	console.error("Error requesting notification permission:", error);
  }
};
